<template>
  <div>
    <div id="dialogTarget" class="control-section; position:relative" style="height: 350px">
      <!-- Render modal Dialog -->
      <ejs-dialog
        ref="modalDialog"
        :isModal="true"
        header="FOIP Disclosure"
        target="#app"
        width="750px"
        :closeOnEscape="false"
        :animationSettings="{ effect: 'None' }"
      >
        <div class="align-center">
          <div class="e-card-content margin-color-verify-section">
            <div>
              <form class="login" @submit.prevent="submitFOIP">
                <div>
                  <p style="text-align: justify" v-html="foipStaticMessage"></p>
                </div>
                <div class="align-right">
                  <ejs-checkbox
                    label="I agree"
                    v-model="isIAgree"
                    :checked="isIAgree"
                    @change="onCheckboxChange"
                  >
                  </ejs-checkbox>
                  <span style="color: red; display: block; margin-bottom: 2%">
                    {{ erorrMessage }}
                  </span>
                </div>
              </form>
            </div>

            <div class="align-center-bottom">
              <ejs-button
                type="button"
                v-on:click.native="onFoipSubmit"
                cssClass="e-info margin-button"
                >Submit</ejs-button
              >
            </div>
          </div>
        </div>
      </ejs-dialog>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";

import {
  STATIC_MESSAGE,
  USER_PROFILES,
  // GET_USER_PROFILES_BY_ID,
} from '@/modules/user-accounts/store';
import { SIGN_USER_OUT } from "../store";

Vue.use(DialogPlugin);
Vue.use(ButtonPlugin);

export default {
  name: "ForceEnterFoip",
  data() {
    return {
      foipStaticMessage: '',
      isIAgree: false,
      erorrMessage: '',
      redirectUrl: '',
      redirectQuery: '',
    };
  },
  async created() {
    this.redirectUrl = this.$route.query.redirect || '';
    this.redirectQuery = this.$route.query.qp || '';
    await this.$store.dispatch(STATIC_MESSAGE, { messageType: 'foip' });
    this.foipStaticMessage = this.$store.getters.staticMessage;
  },
  mounted() {
    // signout when user clicks on the back button in the browser
    window.onpopstate = () => {
      this.$store.dispatch(SIGN_USER_OUT);
    };
  },
  computed: {
    loggedUser() {
      return this.$store.getters.loggedUser;
    },
    userProfile() {
      return this.$store.getters.userProfilesbyID;
    },
  },
  methods: {
    async onFoipSubmit() {
      if (this.isIAgree) {
        this.erorrMessage = '';
        const userProfile = { ...this.$store.getters.userProfilesbyID };
        userProfile.foip = true;
        userProfile.foipAgreementDate = new Date();
        try {
          await this.$store.dispatch(USER_PROFILES, userProfile);
          this.$parent.notificationToasts.push({
            title: "Success!",
            content: 'Your FOIP Disclosure has successfully saved.',
            cssClass: "e-toast-success",
            timeOut: 5000,
          });
          this.$parent.$refs.notifierRef.show();
          const path = `/${this.redirectUrl}`;
          const query = this.redirectQuery ? { [this.redirectQuery]: true } : {};
          this.$router.push({ path, query });

          this.$refs.modalDialog.hide();
        } catch (err) {
          console.error('ERROR:', err.message);
        }
      } else {
        this.erorrMessage = 'Please check "I Agree" box if you want to proceed.';
      }
    },
    onCheckboxChange() {
      this.erorrMessage = '';
    },
  },
};
</script>
<style>
@import "../../../../node_modules/@syncfusion/ej2-vue-popups/styles/material.css";

.control-section {
  height: 100%;
  min-height: 200px;
}
.wrap {
  box-sizing: border-box;
  margin: 0 auto;
  width: 260px;
}
.e-dlg-container .e-float-input {
  margin: 17px 0;
}
.e-dlg-container .wrap .e-control .e-btn {
  margin: 3% 26%;
}

.text-center {
  text-align: center;
}

#content {
  margin-top: 12px;
}

.e-dlg-container .e-footer-content {
  padding: 20px 0 0;
  width: 100%;
}

.e-dlg-container .e-dialog .e-footer-content .e-btn {
  width: 100%;
  height: 36px;
  margin-left: 0px;
}

.e-dlg-container .e-dialog .e-footer-content {
  padding: 0 18px 18px;
}
.e-dlg-container .e-dialog .e-dlg-header-content .e-dlg-header {
  color: #fff;
  font-weight: 500;
  text-align: center;
  width: 100%;
  font-size: 20px;
}
.e-dlg-header-content {
  background-color: #0f4b90;
}
.align-center-bottom {
  display: block;
  text-align: center;
  margin-top: 5%;
}
.align-center-force-password {
  justify-content: center;
}
.e-btn.e-info,
.e-css.e-btn.e-info {
  /* height: 35px; */
  background-color: #dba832 !important;
  color: white !important;
}
.e-btn.e-info:hover,
.e-css.e-btn.e-info:hover {
  background-color: #dba832 !important;
  color: white !important;
}
.e-btn.e-info:active,
.e-btn.e-info.e-active,
.e-css.e-btn.e-info:active,
.e-css.e-btn.e-info.e-active {
  background-color: #dba832 !important;
  color: white i !important;
}
.e-popup.e-popup-open.e-dialog {
  width: 750px !important;
}
</style>
